/// <amd-module name="Release/DeletedPipelines/DeletedPipelinesUIService" />

import { VssService, Services } from "VSS/Platform/Context";

import { IDeletedPipelinesUIService } from "IDeletedPipelinesUIService";
import { getDeletedPipelinesView } from "./DeletedPipelines";
import { getInfoPage } from "./InfoPage";

export class DeletePipelinesUIService extends VssService implements IDeletedPipelinesUIService {
    public getLeftPaneUI(): React.ReactNode {
        return getDeletedPipelinesView();
    }

    public getRightPaneUI(
        onPipelineUndeleted?: (pipelineId: number, pipelineName: string) => void,
        onUndeleteFailed?: (pipelineId: number, pipelineName: string, error: any) => void,
        markTTI?: () => void): React.ReactNode {
        return getInfoPage(onPipelineUndeleted, onUndeleteFailed, markTTI);
    }
}

Services.add("IDeletedPipelinesUIService", { serviceFactory: DeletePipelinesUIService });
